import * as CONSTANTS from '../constants/actions/parts';
import * as CONFIG from '../constants/config/parts';
import { COMPARISONS } from '../constants/config/filters';
import * as PARAMETERS from '../constants/config/parameters';
import * as HASH from '../constants/config/hash';
import * as PARTS from "../constants/config/parts";
import { sortNewest, sortOldest } from '../utilities/arrays';

/** 
 * @name INITIAL_STATE
 * @constant 
 * @description
 * @type {Object}
 * @default
*/
const INITIAL_STATE = {
    allData: [],
    data: [],
    popup: {},
    selected: [],
    pageSize: CONFIG.PAGE_SIZE,
    s3Type: null
};

function getPage( page, data, pageSize ){
    let pageData = [ ...data ],
    startIndex = ( ( page * pageSize ) - pageSize ); // subtract page size to get first record in the group
    return pageData.splice( startIndex, pageSize );
}

function getPageCount( total, pageSize ){
    return Math.ceil( total / pageSize )
}

function isBlank( field ){
    return ( field.value.length === 0 || ( field.value.length === 1 && field.value[ 0 ] === "" ) || field.displayValue === "" )
}

function getFilteredData ( currentData, filter = [], key, compare, selected, filterLength = 0, ignoredBlankParams=[], andToggle = false ) {
    let activeData = [];
    currentData.forEach( part => {
        let include = true,
        filterExact = undefined,
        filtersGreater = undefined,
        filterLesser = undefined;
        //unaltered filters
        if( !compare && filterLength === 0 ) return activeData.push( part );
    
        // filters
        let field = part[ key ];
        if ( filter.length > 0 && field ){

            // if the field is blank and is included in the blank fields, don't bother filtering
            if( ignoredBlankParams.includes( key ) && isBlank( field ) ){
                filterExact = true;

            // apply filters to every one else
            } else {
                if (andToggle) {
                    filterExact = filter.every((criterion) => field.value.includes(criterion.value));
                } else {

                filter.forEach( criterion => {

                    switch( criterion.comparison ){

                        case COMPARISONS.ALL: 
                            if( filterExact ) return;
                            filterExact = true;
                            break;

                        case COMPARISONS.EXACT:
                            if( filterExact ) return;
                            filterExact = field.value.some( value => value === criterion.value.trim() );
                            
                            break;

                        case COMPARISONS.GREATER_THAN:
                            if( filtersGreater ) return;
                            filtersGreater = field.value.some( value => {
                                let a = Number( value ),
                                b = Number( criterion.value );

                                // handle text "min" value, all values are greater than the min
                                if( criterion.value === COMPARISONS.MIN ) return true;

                                return ( a >= b );
                            });
                            break;

                        case COMPARISONS.INCLUDES: {
                            if( filterExact ) return;
                            
                            const invalidCharsRegex = /\*|\\|\(|\)|\[|\]|\+/g, // to replace chars that will break the regexp
                                pattern = ( criterion.value || '' ).trim().replace( invalidCharsRegex, '' ),
                                microPrefixRegex = /μ/gi,
                                flexiblePattern = pattern.replace( microPrefixRegex, 'u' ),
                                displayValue = field.displayValue.replace( microPrefixRegex, 'u' ).replace( invalidCharsRegex, '' ),
                                regex = new RegExp( flexiblePattern, 'gi' );

                            filterExact = regex.test( displayValue );
                            break;
                        }
                        case COMPARISONS.LESS_THAN:
                            if( filterLesser ) return;
                            filterLesser = field.value.some( value => {
                                let a = Number( value ),
                                b = Number( criterion.value );

                                // handle text "max" value, all values are less than the max
                                if( criterion.value === COMPARISONS.MAX ) return true;

                                return ( a <= b );
                            });
                            break;
                        case COMPARISONS.NONE: 
                            if( filterExact !== undefined ) return;
                            filterExact = false;
                            break;

                        default:
                            // do nothing
                            break;
                    }
                });
                }
            }
        }
        // for no key / field present.
        else if ( filter.length > 0 && !field) {
            // if the field is blank and is included in the blank fields, don't bother filtering
            if( ignoredBlankParams.includes( key ) ){
                filterExact = true;
            }
            else {
                filterExact = false;

                // check if blank filter is issued.
                filter.forEach( criterion => {
                    if (criterion.value === "") {
                        filterExact = true;
                    }
                });
            }
        }
        
        // exact match only
        if( filterExact !== undefined && filtersGreater === undefined && filterLesser === undefined ){
            include = filterExact;

        // greater only
        } else if( filterExact === undefined && filtersGreater !== undefined && filterLesser === undefined ){
            include = filtersGreater;

        // lesser only
        } else if( filterExact === undefined && filtersGreater === undefined && filterLesser !== undefined ){
            include = filterLesser;

        // exact and greater 
        } else if( filterExact !== undefined && filtersGreater !== undefined && filterLesser === undefined ){
            include = ( filterExact && filtersGreater );

        // exact and lesser
        } else if( filterExact !== undefined && filtersGreater === undefined && filterLesser !== undefined ){
            include = ( filterExact && filterLesser );

        // lesser and greater
        } else if( filterExact === undefined && filtersGreater !== undefined && filterLesser !== undefined ){
            include = ( filtersGreater && filterLesser );
        }
        // compare
        if( compare && !selected.includes( part.id ) ) include = false;

        if( include ) activeData.push( part );
        
    });
    return activeData;
}

/**
 * **DO NOT** Manipulate the state directly, always apply to a new object first!! If you don't redux will not 
 * recognize a change in the data and the components will not receive the correct information.
 * 
 * @name reducer
 * @function
 * @description Handles reduction of data accross components for the piece of the site implied by the filename
 * @param {Object} state Current state of the data
 * @param {Object} action Information passed from the corresponding actions file
 */
const reducer = ( state = INITIAL_STATE, action ) => {
    
    var data,
    pageCount;

    /** 
     * Meta example case:
     *      case CONSTANTS[ whateverTheActionIs ]:
     *          return { ...state, key: action.payload.key }
     */
	switch( action.type ){
        case CONSTANTS.SELECT_PART:
            let selected;
      
           // const allCheckboxIds = action.payload.parts.map((item) => item.id);
            const allCheckboxIds = state.allData.map((item) => item.id);
            if (action.payload.id === PARTS.SELECT_ALL){
              if (
                state.selected.length === 0 ||
                state.selected.length !== allCheckboxIds.length
              ) {
                selected = allCheckboxIds;
              } else {
                selected = [];
              }
            } else {
              const selectedIndex = state.selected.indexOf(action.payload.id);
              selected = [...state.selected];
              if (selectedIndex === -1) {
                selected.push(action.payload.id);
              } else {
                selected.splice(selectedIndex, 1);
              }
            }
      
            return { ...state, selected };

        case CONSTANTS.SET_PAGE:
            data = getPage( action.payload.page, state.filteredData, state.pageSize );
            return { ...state, data, currentPage: action.payload.page }

        case CONSTANTS.SET_PAGE_SIZE:
            data = getPage( 1, state.filteredData, action.payload.pageSize );
            pageCount = getPageCount( state.filteredData.length, action.payload.pageSize );
            return { ...state,  pageSize: action.payload.pageSize, data, pageCount }    

        case CONSTANTS.SET_PARTS:
            let allData = action.payload.parts;

            pageCount = getPageCount( allData.length, state.pageSize );
            data = getPage( 1, allData, state.pageSize );

            return { ...state, allData, filteredData: allData, data, count: action.payload.parts.length, pageCount, currentPage: 1 }
        
        case CONSTANTS.SET_POPUP:
            let part = state.data.find( part => part.id === action.payload.id );
            return { 
                ...state, 
                popup: { 
                    id: action.payload.id,
                    coords: action.payload.coords, 
                    part: !part ?
                        undefined :
                        { 
                            model: part[ '0' ].displayValue,
                            generic: part[ '0' ].generic,
                            description: part[PARAMETERS.DESCRIPTION]?.displayValue,
                            status: part[PARAMETERS.STATUS]?.displayValue,
                            thumbnail: part[PARAMETERS.THUMBNAIL]?.value[ 0 ]
                        } 
                } 
            };

        case CONSTANTS.APPLY_HASH_CHANGE:            
            let filters = ( action.payload.filters ) ? Object.keys( action.payload.filters ) : [],
            filteredData = [],
            currentData,
            filter = [],
            selectedRow = action.payload.selected || state.selected,
            partsActive = false;
            
            //shift textfilter to last
            if( filters[0] === "0" ) {
                filters.push(filters.shift());
                partsActive = true;
            }

            // loop filter if exist
            if( filters.length > 0 ) {
                for (let i = 0; i < filters.length; i++) {
                    currentData = (filteredData.length > 0 ) ? filteredData : state.allData;
                    filter = action.payload.filters[ filters[i] ];
                    filteredData = [ ...getFilteredData( currentData, filter,  filters[i], action.payload.compare, selectedRow, filters.length, action.payload.ignoredBlanks, action.payload.andToggle.includes(filters[i]) )];
                    if (filteredData.length === 0 ) break;
                }
            } else {
                currentData = ( filteredData.length > 0 ) ? filteredData : state.allData;
                filteredData = [ ...getFilteredData( currentData, filter, 0, action.payload.compare, selectedRow, action.payload.ignoredBlanks )];
            }
            if( action.payload.sorted.length > 0 ) {

                const units = {
                    B: 1,
                    KB: 1024,
                    MB: 1024 ** 2,
                    GB: 1024 * 3,
                    M:  1024 ** 2,
                    G: 1024 ** 3, 
                    'mA': 1,
                    'µA': 0.001
                };

                const isStrictISODate = (str) => {
                    const match = /^\d{4}-\d{2}-\d{2}$/.test(str);
                    if (!match) return false;
                  
                    const date = new Date(str);
                    return !isNaN(date.getTime()) && str === date.toISOString().slice(0, 10);
                };

                const parseSize = (size) => {
                    if (typeof size !== 'string') {
                        size = String(size);    
                    }  

                    // check for date format
                    if (isStrictISODate(size)) {
                        return size;
                    }

                    //const regex = /(\d+(?:\.\d+)?)\s*(B|KB|MB|GB|M|G|mA|µA)/i;
                    //const regex = /(\d+(?:\.\d+)?)\s*(?:x\s*(\d+(?:\.\d+)?))?\s*([a-zA-Zµ]*)/i;
                    const regex = /([-+]\d+(?:\.\d+)?)\s*([a-zA-Zµ]*)/i;
                    
                    const match = size.match(regex);

                    if (match){
                        const number = parseFloat(match[1]);
                        const unit = match[2] ? match[2].toUpperCase() : 'B'; // Default to Bite if no unit is mentioned
                        return number * (units[unit] || 1);
                    }                      
                    return size;
                };

                const isNumeric = (value) => !isNaN(parseFloat(value)) && isFinite(value);

                // for string sorting
                const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' }),
                    columnsToSort = action.payload.sorted,
                    shouldSortNewest = columnsToSort.some( ( [ parameter ] ) => parameter === PARAMETERS.NEWEST ),
                    shouldSortOldest = columnsToSort.some( ( [ parameter ] ) => parameter === PARAMETERS.OLDEST ),
                    isSingleColumnSort = columnsToSort.length === 1,
                    firstParameter = columnsToSort[ 0 ] ? columnsToSort[ 0 ][ 0 ] : null,
                    isEmpty = ( value, parameter ) => (
                        value === '' 
                        || ( parameter === PARAMETERS.INVENTORY && value === '0' )
                    );

                if ( shouldSortNewest ) {
                    filteredData = sortNewest( filteredData );
                } else if ( shouldSortOldest ) {
                    filteredData = sortOldest( filteredData );
                } else {
                    const nonEmptyValues = [],
                        emptyValues = [];             

                    if ( isSingleColumnSort ) {
                        filteredData.forEach( data => {
                            const value = data[ firstParameter ]?.value?.[ 0 ] ?? '';

                            if ( isEmpty( value, firstParameter ) ) {
                                emptyValues.push( data );
                            } else {
                                nonEmptyValues.push( data );
                            }
                        } );
                    }

                    const partsToSort = isSingleColumnSort ? nonEmptyValues : filteredData;

                    partsToSort.sort( ( a, b ) => {
                        // Example columnsToSort => [ ['805', 'desc'], ['0', 'asc'] ]
                        for ( const [ parameter, sortOrder ] of columnsToSort ) {
                            let data1 = a[parameter].value[0],
                                data2 = b[parameter].value[0];
                            
                            const parsedData1 = parseSize( data1 ),
                                parsedData2 = parseSize( data2 ),
                                bothNumeric = isNumeric( parsedData1 ) && isNumeric( parsedData2 ),
                                order = sortOrder === HASH.SORT_ASCENDING ? 1 : -1;
    
                            switch ( action.payload.s3Type ) {
                                case 'math':
                                    data1 = parsedData1;
                                    data2 = parsedData2;
                                    break;

                                case 'numeric':
                                    data1 = isNumeric(parsedData1) ? parsedData1 : data1;
                                    data2 = isNumeric(parsedData2) ? parsedData2 : data2;
                                    break;

                                case 'lookup':
                                    data1 = bothNumeric ? parsedData1 : String(data1);
                                    data2 = bothNumeric ? parsedData2 : String(data2);     
                                    break;

                                default: {
                                    // Default: treat as strings but use Natural Sort
                                    const result = collator.compare(String(data1), String(data2));
                                    return result * order;
                                }
                            }
    
                            // check if both are numeric then sort by numeric values.
                            if (bothNumeric) {
                                data1 = Number(data1);
                                data2 = Number(data2);
                            }

                            if ( !isSingleColumnSort ) {
                                // Keep the empty values to the end
                                if ( isEmpty( data1, parameter ) && !isEmpty( data2, parameter ) ) return 1;
                                if ( isEmpty( data2, parameter ) && !isEmpty( data1, parameter ) ) return -1;
                            }

                            // Break the loop if the current pair doesn't have a tie breaker
                            if ( data1 > data2 ) return 1 * order;
                            if ( data1 < data2 ) return -1 * order;
                        }

                        /**
                         * This needs to be outside the loop to allow other columns
                         * to be considered for sorting in case of a tie breaker
                         */
                        return 0;
                    } );   
                    filteredData = [ ...partsToSort, ...( isSingleColumnSort ? emptyValues : [] ) ];
                }
            }

            //paginate
            data = getPage( 1, filteredData, state.pageSize );
            pageCount = getPageCount( filteredData.length, state.pageSize );

            return { ...state, data, filteredData, pageCount, count: filteredData.length, currentPage: 1, partsActive };

        case CONSTANTS.RESET_PARTS:
            return { ...state, selected: [] };

		default:
			return state;
    }
    
}

export default reducer;